import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import VocabularyThemeFormContainer from './VocabularyThemeFormContainer';

const VocabularyThemeFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: `${props.params.vocabularyThemeId ? 'Edit Vocabulary Theme' : 'Create Vocabulary Theme'}`,
        },
      ]}
    />
    <Card
      title={props.params.vocabularyThemeId ? 'Edit Vocabulary Theme' : 'Create Vocabulary Theme'}
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <VocabularyThemeFormContainer vocabularyThemeId={props.params.vocabularyThemeId} />
    </Card>
  </div>
);

VocabularyThemeFormScene.propTypes = {
  params: PropTypes.shape({
    vocabularyThemeId: PropTypes.string,
  }),
};

VocabularyThemeFormScene.defaultProps = {
  params: null,
};

export default VocabularyThemeFormScene;
